export default __webpack_public_path__ + "static/media/close.b43b0d13.svg";